import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject, NgZone, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { catchError, throwError } from 'rxjs';
import { ErrorDialog } from './error-dialog/error-dialog';
import { ApiError } from './error.model';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const dialog     = inject(MatDialog);
  const zone       = inject(NgZone);
  const platformId = inject(PLATFORM_ID);

  if (req.headers.has('X-Skip-Error-Dialog')) {
    return next(req);
  }

  return next(req).pipe(
    catchError((err: HttpErrorResponse) => {
      // 401 é tratado pelo authInterceptor
      if (err.status === 401) {
        return throwError(() => err);
      }

      // MatDialog requer browser e zona Angular
      if (isPlatformBrowser(platformId) && dialog.openDialogs.length === 0) {
        const apiError: ApiError = {
          status: err.status ?? 0,
          error: err.error?.error ?? err.statusText ?? 'Erro desconhecido',
          message: err.error?.message ?? 'Ocorreu um erro inesperado',
          details: err.error?.details,
          data: err.error?.data,
          timestamp: err.error?.timestamp ?? new Date().toISOString(),
          path: err.error?.path,
        };

        zone.run(() => {
          dialog.open(ErrorDialog, {
            data: apiError,
            maxWidth: '560px',
            width: '100%',
          });
        });
      }

      return throwError(() => err);
    }),
  );
};
